import { render } from "./PromoSpot.vue?vue&type=template&id=bb321444&scoped=true"
import script from "./PromoSpot.vue?vue&type=script&lang=js"
export * from "./PromoSpot.vue?vue&type=script&lang=js"

import "./PromoSpot.vue?vue&type=style&index=0&id=bb321444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb321444"]])

export default __exports__